import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Building, Monitor, ChevronRight, User } from "lucide-react";
import { Button } from "../../pages/protected/admin/components/AdminSharedComponents";

const LayoutHeader = ({ breadcrumbs = [] }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  // Ambil data user login dari localStorage
  const storedUser = localStorage.getItem("user");
  const user = storedUser ? JSON.parse(storedUser) : null;

  const handleSwitch = async () => {
    setIsLoading(true);

    setTimeout(() => {
      if (location.pathname.startsWith("/monitoring")) {
        navigate("/admin/dashboard");
      } else {
        navigate("/monitoring/overview");
      }
      setIsLoading(false);
    }, 100);
  };

  const isMonitoring = location.pathname.startsWith("/monitoring");

  return (
    <nav className="bg-white p-4 shadow-sm">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        {/* Left section: User info and breadcrumbs */}
        <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4 min-w-0">
          {user?.name && (
            <div className="hidden xl:flex items-center gap-2 px-3 py-1.5 bg-gray-50 rounded-xl">
              <User size={20} className="text-gray-500" />
              <span className="text-sm sm:text-md font-medium text-gray-700 truncate">
                Welcome, <span className="font-semibold">{user.name}</span>
              </span>
            </div>
          )}

          {breadcrumbs.length > 0 && (
            <>
              <div className="hidden sm:block w-px h-5 bg-gray-300"></div>
              <ol className="flex flex-wrap items-center text-sm sm:text-md text-deep min-w-0">
                {breadcrumbs.map(({ match, breadcrumb }, index) => (
                  <React.Fragment key={match.pathname}>
                    <li className="min-w-0">
                      <Link
                        to={match.pathname}
                        className="hover:text-primary transition-colors duration-150 px-2 py-1 rounded-xl hover:bg-gray-50 block truncate"
                      >
                        {breadcrumb}
                      </Link>
                    </li>
                    {index < breadcrumbs.length - 1 && (
                      <li className="mx-1 sm:mx-2 flex-shrink-0">
                        <ChevronRight size={14} className="text-gray-400" />
                      </li>
                    )}
                  </React.Fragment>
                ))}
              </ol>
            </>
          )}
        </div>

        {/* Right section: Mode indicator and switch button */}
        <div className="hidden xl:flex items-center justify-between sm:justify-end gap-3 flex-shrink-0">
          <div className="flex items-center gap-2 px-3 py-1 rounded-full bg-gray-100 text-xs sm:text-sm font-medium text-gray-600">
            <div
              className={`w-2 h-2 rounded-full transition-colors duration-300 ${
                isMonitoring
                  ? "bg-blue-500 animate-pulse"
                  : "bg-green-500 animate-pulse"
              }`}
            ></div>
            <span className="hidden xs:inline">
              {isMonitoring ? "Monitoring Mode" : "Admin Mode"}
            </span>
            <span className="xs:hidden">
              {isMonitoring ? "Monitoring" : "Admin"}
            </span>
          </div>

          <Button
            onClick={handleSwitch}
            variant={isMonitoring ? "deep" : "primary"}
            className={`
              px-3 sm:px-4 py-2 rounded-lg transition-all duration-150 text-sm sm:text-base
              ${isLoading ? "opacity-75 cursor-wait" : "hover:shadow-sm"}
            `}
            icon={isLoading ? null : isMonitoring ? Building : Monitor}
            disabled={isLoading}
          >
            {isLoading ? (
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
                <span className="hidden sm:inline">Switching...</span>
              </div>
            ) : (
              <>
                <span className="hidden sm:inline">
                  {isMonitoring ? "Switch to Admin" : "Switch to Monitoring"}
                </span>
                <span className="sm:hidden">
                  {isMonitoring ? "Admin" : "Monitor"}
                </span>
              </>
            )}
          </Button>
        </div>
      </div>
    </nav>
  );
};

export default LayoutHeader;
